import { MutationTree } from "vuex";
import { SelfieState } from "../types";

const mutations: MutationTree<SelfieState> = {
  setTurnDirection(state, turnDirection) {
    state.turnDirection = turnDirection;
  },
};

export default mutations;
